import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Técnicas de internet que funcionan una noche y la siguiente no', 'Consejos contradictorios de familiares bien intencionados', 'Sin rutina clara, sin protocolo, sin mapa', 'Regresiones que aparecen sin aviso y sin saber qué hacer', 'Agotamiento que ya afecta tu trabajo, tu pareja y tu salud', 'La misma madrugada, la semana que viene'];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-190">
      <div className="bg-navy-800/40 border border-navy-700 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-191">
        <div className="space-y-6" data-id="element-192">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4" data-id="element-193">
              <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-1" data-id="element-194" />
              <p className="text-lg md:text-xl text-blue-100" data-id="element-195">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-12 text-center" data-id="element-196">
          <h3 className="text-2xl md:text-3xl font-bold text-gold-400" data-id="element-197">
            ¿Y si esta fuera la última noche que la pasás así?
          </h3>
        </motion.div>
      </div>
    </section>;
}